import React from "react";

import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";

import { I18n } from "@aws-amplify/core";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import PrintIcon from '@material-ui/icons/Print'

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";
import { fetchGet, fetchPatch, fetchPut } from "../../api/fetch";
import {
    printZebraLabel,
    needUserSelectPrinter,
    getLabelPrinterDevices,
    setPrinterWidthConfig,
    selectPrinter
} from "../../utils/labels";
import { calcProductState } from "../VMI/ProductUtil";

import CloseIcon from "../Common/CloseIcon";
import CustomSelect from "../Common/CustomSelect";
import CustomInput from "../Common/CustomInput";
import NuvButton from '../Common/NuvButton';
import MessageDialog, { MessageStatus } from "../Common/MessageDialog";
import CalculateQuantity from "./CalculateQuantity";
import DissociateProduct from "./DissociateProduct";
import PrinterSelection from "./PrinterSelection";
import PziUnitsList from "./PziUnitsList";

const PRODUCT_ATTR_WEIGHT_ITEM = 240;
const PRODUCT_ATTR_WEIGHT_UOM = 241; // Unit of weight
const PRODUCT_ATTR_WEIGHT_UOM_LB = 158; // sys_attribute_id_picklist.id
const PZI_ATTR_MIN_QUANT = 224;
const PZI_ATTR_MIN_LEVEL = 238;
const PZI_ATTR_MIN_LEVEL_QUARTER = 145;
const PZI_ATTR_MAX_QUANT = 223;
const PZI_ATTR_MAX_LEVEL = 239;
const PZI_ATTR_MAX_LEVEL_FULL = 152;
const PZI_ATTR_UNITS = 231;
const PZI_ATTR_BASE_UNIT = 216;

export function isValidEoq(value) {
    if (value === '' || value === null || value === undefined) return true;
    const num = Number(value);
    return Number.isInteger(num) && num >= 0 && num <= 99999;
}

const styles = {
    productName: {
        color: colors.black87,
        fontSize: 16,
        fontWeight: 500,
        marginRight: 10
    },
    expandedArrow: {
        marginRight: 10,
        top: -1,
        "&:hover": {
            textDecoration: "none",
            color: "black"
        },
        "&:visited": {
            textDecoration: "none",
            color: "black"
        },
        "&:active": {
            textDecoration: "none",
            color: "black"
        },
        "&:link": {
            textDecoration: "none",
            color: "black"
        }
    },
    vendorNum: {
        color: colors.black87,
        fontSize: 14,
    },
    pziLeftCol: {
        display: "inline-block"
    },
    pziRightCol: {
        left: 24,
        display: "inline-block"
    },
    information: {
        left: 15,
        marginBottom: 40,
        display: "flex"
    },
    subHeader: {
        fontSize: 14,
        color: colors.black54,
        fontWeight: 450
    },
    pziLeftColBox: {
        width: 328,
        border: "1px solid #dddddd",
        padding: 8
    },
    pziRightColBox: {
        width: 360,
        border: "1px solid #dddddd",
        padding: 8,
        "&:not(:last-child)": {
            marginBottom: 24
        },
        "&:last-child": {
            lineHeight: 1.143,
        }
    },
    pziInstructions: {
        fontStyle: "italic",
        color: colors.black87,
        fontSize: 14,
        marginBottom: 16
    },
    pziBaseUnit: {
        color: colors.black54,
        fontSize: 14,
        "& span": {
            "&:first-child": {
                color: colors.black87,
            }
        },
        marginBottom: 8
    },
    subCategory: {
        color: "black",
        fontSize: 14,
        fontWeight: 500
    },
    subDiv: {
        "&:not(:last-child)": {
            marginBottom: 24
        }
    },
    inputWeight: {
        padding: 8,
        width: 50
    },
    inputQuantity: {
        padding: 8,
        width: 80,
    },
    inputQuantity2: {
        padding: 8,
        width: 80,
        marginRight: 18
    },
    unitWeight: {
        marginLeft: 10,
        width: 60,
        height: 40
    },
    editButton: {
        backgroundColor: "transparent"
    },
    pziOpenOrderRequests: {
        color: "red",
        marginLeft: 10
    }
};

const ProductAssociationBase = (props) => {
    const {
        classes,
        language,
        data,
        removeProduct,
        updateProduct,
        massUnitsAsObj,
        massUnitMeasurements,
        minQuantLevelOptions,
        maxQuantLevelOptions,
        setEditProductAssociation,
        editProductAssociation,
        componentId,
        setEditWarningProductAssociation,
    } = props;

    const prUnitsAssoc = parseUnits(data['units']);

    const [expanded, setExpanded] = React.useState(true);

    const [weightItem, setWeightItem] = React.useState();
    const [weightItemTmp, setWeightItemTmp] = React.useState();
    const [weightUom, setWeightUom] = React.useState();
    const [weightUomTmp, setWeightUomTmp] = React.useState();

    const [pziQuantity, setPziQuantity] = React.useState();
    const [pziQuantityTmp, setPziQuantityTmp] = React.useState(null);

    const [minQuant, setMinQuant] = React.useState();
    const [minQuantTmp, setMinQuantTmp] = React.useState(null);
    const [minLevel, setMinLevel] = React.useState();
    const [minLevelLbl, setMinLevelLbl] = React.useState();
    const [minLevelTmp, setMinLevelTmp] = React.useState();
    const [maxQuant, setMaxQuant] = React.useState();
    const [maxQuantTmp, setMaxQuantTmp] = React.useState(null);
    const [maxLevel, setMaxLevel] = React.useState();
    const [maxLevelLbl, setMaxLevelLbl] = React.useState();
    const [maxLevelTmp, setMaxLevelTmp] = React.useState();
    const [selectedUnits, setSelectedUnits] = React.useState();
    const [selectedUnitsTmp, setSelectedUnitsTmp] = React.useState();
    const [pziUnits, setPziUnits] = React.useState(data['units']);

    const [scaleDlgOpen, setScaleDlgOpen] = React.useState(false);
    const [dlgWeightItem, setDlgWeightItem] = React.useState(null);
    const [dlgWeightItemTmp, setDlgWeightItemTmp] = React.useState(null);

    const [disWindow, openDisWindow] = React.useState(false);

    const [pziBaseUnitDisplay, setPziBaseUnitDisplay] = React.useState();
    const [pziBaseUnit, setPziBaseUnit] = React.useState();
    const [pziBaseUnitTmp, setPziBaseUnitTmp] = React.useState();
    const [pziBaseUnitOptions, setPziBaseUnitOptions] = React.useState();

    const [printFormat, setPrintFormat] = React.useState(null);
    const label2x1 = I18n.get("label_printer_format_2x1");
    const label4x1 = I18n.get("label_printer_format_4x1");
  
    const [eoq, setEoq] = React.useState(null);
    const [eoqTmp, setEoqTmp] = React.useState('');


    React.useEffect(() => {
        // Clear the item and attributes and fetch the item and the tree.
        try {
            let pziAttrs = Object.assign({}, ...props.data['attributes'].map(
                ({
                    sys_attribute_id,
                    attribute_value,
                    picklist,
                    data_type_id
                }) => ({
                    [sys_attribute_id]: {
                        attribute_value, 
                        picklist,
                        data_type_id
                    }
                })
            ));
            let attrib;

            setWeightUom(data["weight_scale"]);
            if (data['weight_scale']) {
                setWeightUomTmp(data['weight_scale']);
            } else {
                setWeightUomTmp(PRODUCT_ATTR_WEIGHT_UOM_LB); // Give the select a default unit of measure.
            }

            setWeightItem(data["unitary_weight"]);
            setWeightItemTmp(data["unitary_weight"]);
            setDlgWeightItem(data["unitary_weight"]);
            setDlgWeightItemTmp(data["unitary_weight"]);

            attrib = pziAttrs[PZI_ATTR_MIN_QUANT];
            if (attrib) {
                setMinQuant(attrib["attribute_value"]);
                setMinQuantTmp(attrib["attribute_value"]);
            } else {
                setMinQuantTmp('');
            }

            attrib = pziAttrs[PZI_ATTR_MIN_LEVEL];
            if (attrib) {
                setMinLevel(parseInt(attrib["attribute_value"]));
                setMinLevelLbl(attrib['picklist'][`name_${language}`]);
                setMinLevelTmp(parseInt(attrib["attribute_value"]));
            } else {
                setMinLevelTmp(PZI_ATTR_MIN_LEVEL_QUARTER);
            }

            attrib = pziAttrs[PZI_ATTR_MAX_QUANT];
            if (attrib) {
                setMaxQuant(attrib["attribute_value"]);
                setMaxQuantTmp(attrib["attribute_value"]);
            } else {
                setMaxQuantTmp('');
            }

            attrib = pziAttrs[PZI_ATTR_MAX_LEVEL];
            if (attrib) {
                setMaxLevel(attrib["attribute_value"])
                setMaxLevelLbl(attrib['picklist'][`name_${language}`]);
                setMaxLevelTmp(attrib["attribute_value"]);
            } else {
                setMaxLevelTmp(PZI_ATTR_MAX_LEVEL_FULL);
            }

            setPziQuantity(data["quantity"]);
            setPziQuantityTmp(data["quantity"] ? data["quantity"] : '');

            attrib = pziAttrs[PZI_ATTR_BASE_UNIT]
            if (attrib) {
                setPziBaseUnit(attrib['attribute_value']);
                setPziBaseUnitTmp(attrib['attribute_value'])
                setPziBaseUnitDisplay(attrib['attribute_value'] === data['base_unit'] ? 
                    attrib['attribute_value'] + " (" + I18n.get("default") + ")" : 
                    attrib['attribute_value']);
                setPziUnits(calcPziUnits(attrib['attribute_value']));
            } else {
                setPziUnits(calcPziUnits(data['base_unit']));
            }

            attrib = pziAttrs[PZI_ATTR_UNITS];
            let selUnits;
            if (attrib) {
                selUnits = attrib["attribute_value"];
            } else {
                const emptyPziUnits = "{\"Units\": []}";
                selUnits = emptyPziUnits;
            }
            setSelectedUnitsTmp(selUnits);
            setSelectedUnits(selUnits);

            setPziBaseUnitOptions(calcBaseUnitOptions(data['units'], data['base_unit']));

            setEoq(data["economic_order_quantity"]);
            setEoqTmp(data["economic_order_quantity"] != null ? data["economic_order_quantity"] : '');
        } catch (e) {
            console.log(e)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dlgWeightItem, data]);

    function calcBaseUnitOptions(unitsJson, prBaseUnit) {
        let units = JSON.parse(unitsJson)
        let options = [];
        for(let i = 0; units && units['units'] && i < units['units'].length; i++) {
            let unit = units['units'][i];
            let name = unit['bc_code'] === prBaseUnit ? unit['bc_code'] + " (" + I18n.get("default") + ")" : unit['bc_code'];
            options.push({id: unit['bc_code'], name: name});
        }
        return options;
    }

    function parseUnits(unitsStr) {
        let units = JSON.parse(unitsStr);
        let unitsAssoc = Object.assign({}, ...units['units'].map(
            ({
                bc_code,
                quantity,
                i18n_key
            }) => ({
                [bc_code]: {
                    quantity, 
                    i18n_key
                }
            })
        ));
        return unitsAssoc;
    }

    function calcPziUnits(pziBaseUnit) {
        let pziBaseUnitQty = prUnitsAssoc[pziBaseUnit]['quantity'];
        let pziUnits = {"units": []};
        for (let bcCode in prUnitsAssoc) {
            pziUnits['units'].push({
                bc_code: bcCode, 
                quantity: prUnitsAssoc[bcCode]['quantity'] / pziBaseUnitQty, 
                i18n_key: prUnitsAssoc[bcCode]['i18n_key']
            })
        }
        return JSON.stringify(pziUnits);
    }

    function calcSelectedUnits(pziBaseUnit, selectedUnits) {
        let selUnitsAssoc = parseUnits(selectedUnits);
        let pziBaseUnitQty = prUnitsAssoc[pziBaseUnit]['quantity'];
        let newSelUnits = {"units": []};
        for (let bcCode in prUnitsAssoc) {
            if (bcCode in selUnitsAssoc) {
                newSelUnits['units'].push({
                    bc_code: bcCode, 
                    quantity: prUnitsAssoc[bcCode]['quantity'] / pziBaseUnitQty, 
                    i18n_key: prUnitsAssoc[bcCode]['i18n_key']
                })
            }
        }
        return JSON.stringify(newSelUnits);
    }

    async function submitChanges() {
        try {
            var new_data = data
            new_data["quantity"] = isNaN(parseInt(pziQuantityTmp)) ? null : pziQuantityTmp;
            var new_attributes = []

            if (minQuantTmp) {
                new_attributes.push({
                    sys_attribute_id: PZI_ATTR_MIN_QUANT,
                    attribute_value: minQuantTmp
                });
            }
            if (minLevelTmp) {
                new_attributes.push({
                    sys_attribute_id: PZI_ATTR_MIN_LEVEL,
                    attribute_value: minLevelTmp,
                });
            }

            if (maxLevelTmp) {
                new_attributes.push({
                    sys_attribute_id: PZI_ATTR_MAX_LEVEL,
                    attribute_value: maxLevelTmp,
                });
            }

            if (maxQuantTmp) {
                new_attributes.push({
                    sys_attribute_id: PZI_ATTR_MAX_QUANT,
                    attribute_value: maxQuantTmp,
                });
            }

            if (pziBaseUnitTmp) {
                new_attributes.push({
                    sys_attribute_id: PZI_ATTR_BASE_UNIT,
                    attribute_value: pziBaseUnitTmp
                });
            }

            if (selectedUnitsTmp) {
                new_attributes.push({
                    sys_attribute_id: PZI_ATTR_UNITS,
                    attribute_value: selectedUnitsTmp
                });
            }

            new_data["attributes"] = new_attributes

            delete new_data["created_by"]
            delete new_data["created_on"]
            await putProductZoneInventory(data['id'], new_data);

            var product_attributes = []

            if (weightItemTmp) {
                product_attributes.push({
                    sys_attribute_id: PRODUCT_ATTR_WEIGHT_ITEM,
                    attribute_value: String(parseFloat(weightItemTmp))
                })
            }

            if (weightUomTmp) {
                product_attributes.push({
                    sys_attribute_id: PRODUCT_ATTR_WEIGHT_UOM,
                    attribute_value: String(parseInt(weightUomTmp))
                })
            }

            // Sauvegarde EOQ + attributs via PUT v2/products
            const eoqValue = eoqTmp === '' ? null : parseInt(eoqTmp);
            await putProductV2(data["product_id"], eoqValue, product_attributes);

            updateProduct();

        } catch (error) {
            console.log(error)
        }
    }

    async function putProductZoneInventory(id, data) {
        await fetchPatch(
            `/product_zone_inventory/${id}`, data
        );
    }

    async function putProductV2(productId, eoqValue, productAttributes) {
        const payload = {
            economic_order_quantity: eoqValue,
        };
        if (productAttributes.length > 0) {
            payload.attributes = productAttributes;
        }
        await fetchPut(`v2/products/${productId}`, payload);
    }

    //Reset Fields if the edit is cancelled
    function resetEdit() {
        setWeightItemTmp(weightItem);
        setDlgWeightItemTmp(dlgWeightItem);
        if (weightUom)
            setWeightUomTmp(weightUom);
        else
            setWeightUomTmp(PRODUCT_ATTR_WEIGHT_UOM_LB);
        setMinQuantTmp(minQuant);
        if (minLevel)
            setMinLevelTmp(minLevel);
        else
            setMinLevelTmp(PZI_ATTR_MIN_LEVEL_QUARTER);
        setMaxQuantTmp(maxQuant);
        if (maxLevel)
            setMaxLevelTmp(maxLevel);
        else
            setMaxLevelTmp(PZI_ATTR_MAX_LEVEL_FULL);
        setPziQuantityTmp(pziQuantity);
        setPziBaseUnitTmp(pziBaseUnit);
        setSelectedUnitsTmp(selectedUnits);
        setEoqTmp(eoq != null ? eoq : '');
    }

    //-----------------------------------------------------------------------
    // Printer Select Dialog related states and functions
    //
    // TODO: All of this should be incorporated int a button component.
    // That way it could be reused at different locations conviniently.
    //-----------------------------------------------------------------------
    const [selectPrinterDialog, setOpenSelectPrinter] = React.useState(false);
    const [labelWidth, setLabelWidth] = React.useState();
    const [labelPrinterDevices, setLabelPrinterDevices] = React.useState();
    const [printingBusy, setPrintingBusy] = React.useState(false);

    const fetchLabel = async (productZoneInventoryId, format) => {
        try {
            let res = await fetchGet(
                `v2/labels/product_zone_inventory/${productZoneInventoryId}?labelSize=${format}`
            );
            return { ...res };
        } catch (e) {
            console.log(e);
        }
    }

    function handleEdit() {
        if (editProductAssociation !== undefined) {
            setEditWarningProductAssociation(componentId)
        } else {
            setEditProductAssociation(componentId)

        }
    }

    function cancelEdit() {
        setEditProductAssociation(undefined)
        resetEdit();
    }

    async function printLabel(format) {
        console.log("print label product associate");
        console.log(format);
        setPrintingBusy(true);
        let label = await fetchLabel(data["id"], format);
        let askUser = await needUserSelectPrinter(label);
        let width = label['label-width'];
        let devices = getLabelPrinterDevices();

        if (askUser) {
            setLabelPrinterDevices(devices);
            setLabelWidth(width);
            setOpenSelectPrinter(true);
        } else {
            if (devices.length < 1) {
                setMessage(I18n.get("label_printer_not_found"));
                setMessageStatus(MessageStatus.NAKED);
                setOpenMessage(true);
            } else {
                selectPrinter(label);
                let status = printZebraLabel(label);

                if (status['status'] !== 200) {
                    setMessage(I18n.get("label_printer_error") + width + I18n.get("label_printer_error_2"));
                    setMessageStatus(MessageStatus.ERROR);
                    setOpenMessage(true);
                }
                console.log("Print label status:" + JSON.stringify(status));
            }
        }
        setPrintingBusy(false);
    }

    function updatePrinterWidthConfig(selectedPrinterUUID) {
        // The user confirmed a selection, update the config.
        setPrinterWidthConfig(labelWidth, selectedPrinterUUID);
        // And print the label.
        printLabel(printFormat);
    }

    //-----------------------------------------------------------------------
    // Error Dialog related states and functions
    //-----------------------------------------------------------------------
    const [messageDialog, setOpenMessage] = React.useState(false); // Boolean
    const [message, setMessage] = React.useState(); // String
    const [messageStatus, setMessageStatus] = React.useState(); // Holds MessageStatus object.
    const isEditMode = editProductAssociation === componentId;
    const hasOpenOrderRequest = data['has_open_order_requests'];

    return (
        <div>
            <Dialog open={scaleDlgOpen}
                onClose={() => { setScaleDlgOpen(false) }}
                aria-labelledby="responsive-dialog-title"
                style={{ padding: "25px" }}
            >
                <CalculateQuantity unit_weight={dlgWeightItemTmp} weight={weightUom} setQuantity={setPziQuantity} handleClose={() => { setScaleDlgOpen(false) }} />
            </Dialog>
            <Dialog open={selectPrinterDialog}>
                <PrinterSelection
                    setOpenSelectPrinter={setOpenSelectPrinter}
                    updatePrinterWidthConfig={updatePrinterWidthConfig}
                    devices={labelPrinterDevices}
                    labelWidth={labelWidth}
                />
            </Dialog>
            <Dialog open={disWindow}
                onClose={() => { openDisWindow(false) }}
                aria-labelledby="responsive-dialog-title"
                style={{ padding: "25px" }}
            >
                <DissociateProduct
                    handleClose={() => { openDisWindow(false) }}
                    id={data["id"]}
                    removeProduct={removeProduct} />
            </Dialog>
            <MessageDialog open={messageDialog}
                message={message}
                status={messageStatus}
                onClose={() => { setOpenMessage(false) }}
            />
            <a className={classes.expandedArrow} onClick={() => setExpanded(!expanded)} href={`#PA${componentId}`}>{expanded ? <>&#9660;</> : <>&#9654;</>}</a><span className={classes.productName}>{data["description_fr"]}</span>
            <Button onClick={() => { openDisWindow(true) }}><img src={images.unlink} alt="plus"></img>&nbsp;&nbsp;<span style={{ fontWeight: 500, color: "#0096a7", position: "relative" }}>{I18n.get("dissociate_product")}</span></Button>
            <NuvButton onClick={() => { setPrintFormat(label2x1); printLabel(label2x1) }} disabled={printingBusy} startIcon={<PrintIcon />} style={{ marginLeft: 24 }}><span>{label2x1}</span></NuvButton>
            <NuvButton onClick={() => { setPrintFormat(label4x1); printLabel(label4x1) }} disabled={printingBusy} startIcon={<PrintIcon />} style={{ marginLeft: 24 }}><span>{label4x1}</span></NuvButton>
            <br />
            {expanded && !(isEditMode) ?
                <div style={{ float: "right" }}>
                    <Button className={classes.editButton} onClick={() => { handleEdit() }}><img src={images.edit_vmi} alt="edit"></img></Button>
                </div>
                : <></>}
            {expanded && isEditMode ?
                <div style={{ display: "-webkit-inline-box", height: 0, float: "right", zIndex: "10" }}>
                    <Button className={classes.editButton} onClick={() => { submitChanges(); setEditProductAssociation(undefined); }}><img src={images.save} alt="edit"></img></Button>
                    <div style={{ top: -4 }}>
                        <CloseIcon closeFunction={() => { cancelEdit() }} />
                    </div>

                </div>
                : <></>}
            <br />
            {
                expanded ?

                    <div className={classes.information}>
                        <div className={classes.pziLeftCol}>
                            <span className={classes.subHeader}>{I18n.get("site_product")}</span>
                            <div className={classes.pziLeftColBox}>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("product_state")}</span><br />
                                    <span className={classes.vendorNum}>{calcProductState(data['blocked'], data['deleted'], data['obsolete'])}</span>
                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("product_code")}</span><br />
                                    <span className={classes.vendorNum}>{data["jrv_code"] || "-"}</span>
                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("vendor_name")}</span><br />
                                    <span className={classes.vendorNum}>{data["vendor_name"] || "-"}</span>
                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("vendor_num")}</span><br />
                                    <span className={classes.vendorNum}>{data["vendor_item_no"] || "-"}</span>
                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("manu_name")}</span><br />
                                    <span className={classes.vendorNum}>{data["manufacturer_name"] || "-"}</span>
                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("manu_code")}</span><br />
                                    <span className={classes.vendorNum}>{data["manufacturer_code"] || "-"}</span>
                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("manu_item_code")}</span><br />
                                    <span className={classes.vendorNum}>{data["manufacturer_item_code"] || "-"}</span>
                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("ogc_reference")}</span><br />
                                    <span className={classes.vendorNum}>{data["ogc"] || "-"}</span>
                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("category")}</span><br />
                                    <span className={classes.vendorNum}>{data["category"] || "-"}</span>
                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("unit_weight")}</span><br />
                                    {isEditMode ?
                                        <div>
                                            <div style={{ width: 300, display: "flex" }}>
                                                <CustomInput
                                                    name={"weight"}
                                                    value={weightItemTmp || "-"}
                                                    onChange={(e) => {
                                                        setWeightItemTmp(e.target.value)
                                                    }}
                                                    type={"number"}
                                                    step={"0.0001"}
                                                    min={0}
                                                />
                                                &nbsp;&nbsp;&nbsp;
                                                <CustomSelect
                                                    name={"type"}
                                                    value={weightUomTmp}
                                                    noSort={true}
                                                    options={massUnitMeasurements}
                                                    onChange={(e) => {
                                                        setWeightUomTmp(e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        :
                                        <span className={classes.vendorNum}>{weightItem !== null ? weightItem + " " + massUnitsAsObj[weightUom] : "-"}</span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className={classes.pziRightCol}>
                            <span className={classes.subHeader}>{I18n.get("common_site2")}</span>
                            <div className={classes.pziRightColBox}>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("code_bin")}</span><br />
                                    <span className={classes.vendorNum}>{data["pzi_id"] || "-"}</span>
                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("min_cap")}</span><br />
                                    {
                                        isEditMode ?
                                            <div>
                                                <span className={classes.vendorNum}>{I18n.get("quantity")}</span>
                                                <input type="number" value={minQuantTmp} onChange={(e) => { setMinQuantTmp(e.target.value) }} className={classes.inputQuantity} ></input>
                                                <span>{I18n.get("unites")}</span><br />
                                                <span className={classes.vendorNum}>{I18n.get("corres_level")}</span>
                                                <div style={{ width: 100, display: "inline-flex" }}>
                                                    <CustomSelect
                                                        name={"type"}
                                                        value={minLevelTmp}
                                                        noSort={true}
                                                        options={minQuantLevelOptions}
                                                        onChange={(e) => { setMinLevelTmp(e.target.value); }}
                                                    />
                                                </div>

                                            </div>
                                            :
                                            <div>
                                                <span className={classes.vendorNum}>{minQuant ? I18n.get("quantity") + minQuant + I18n.get("unites") : "-"}</span><br />
                                                <span className={classes.vendorNum}>{I18n.get("corres_level") + (minLevelLbl || "-")}</span>
                                            </div>
                                    }

                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("max_cap")}</span><br />
                                    {
                                        isEditMode ?

                                            <div>
                                                <span className={classes.vendorNum}>{I18n.get("quantity")}</span>
                                                <input type="number" value={maxQuantTmp} onChange={(e) => { setMaxQuantTmp(e.target.value) }} className={classes.inputQuantity} ></input>
                                                <span>{I18n.get("unites")}</span><br />
                                                <span className={classes.vendorNum}>{I18n.get("corres_level")}</span>
                                                <div style={{ width: 100, display: "inline-flex" }}>
                                                    <CustomSelect
                                                        name={"type"}
                                                        noSort={true}
                                                        value={maxLevelTmp}
                                                        options={maxQuantLevelOptions}
                                                        onChange={(e) => { setMaxLevelTmp(e.target.value); }}
                                                    />
                                                </div>
                                            </div>

                                            :

                                            <div>
                                                <span className={classes.vendorNum}>{maxQuant ? I18n.get("quantity") + maxQuant + I18n.get("unites") : "-"}</span><br />
                                                <span className={classes.vendorNum}>{I18n.get("corres_level") + (maxLevelLbl || "-")}</span>
                                            </div>
                                    }

                                </div>
                                <div className={classes.subDiv}>
                                    <span className={classes.subCategory}>{I18n.get("eoq_title")}</span><br />
                                    {isEditMode ? (
                                        <input
                                            type="number"
                                            min={0}
                                            max={99999}
                                            step={1}
                                            value={eoqTmp}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === '' || (Number.isInteger(Number(val)) && Number(val) >= 0 && Number(val) <= 99999)) {
                                                    setEoqTmp(val);
                                                }
                                            }}
                                            className={classes.inputQuantity}
                                        />
                                    ) : (
                                        <span className={classes.vendorNum}>{eoq != null ? eoq : "-"}</span>
                                    )}
                                </div>
                            </div>

                            <span className={classes.subHeader}>{I18n.get("inventory")}</span>
                            <div className={classes.pziRightColBox}>
                                {/* <span className={classes.subCategory}>{I18n.get("quantity_bin")}: </span> */}
                                {
                                    isEditMode ?
                                        <div>
                                            <input type="number" className={classes.inputQuantity2} value={pziQuantityTmp} onChange={(e) => { setPziQuantityTmp(e.target.value) }}></input>
                                            {/* <img onClick={openScale} src={images.quantity_unit} alt="quantity" style={{ cursor: "pointer" }} /> */}
                                        </div>
                                        :
                                        <span className={classes.vendorNum}>{pziQuantity || "-"}</span>

                                }

                            </div>

                            <span className={classes.subHeader}>{I18n.get("ordering_quantities")}</span>
                            <div className={classes.pziRightColBox}>
                                <div className={classes.pziInstructions}><span>{ isEditMode ? I18n.get("pzi_units_edit_instructions") : I18n.get("pzi_units_view_instructions") }</span></div>
                                <div className={classes.pziBaseUnit}>
                                    <span>{I18n.get("orders_base_unit") + I18n.get("colon")} </span>
                                    { isEditMode && !hasOpenOrderRequest ?
                                        <div style={{ width: 200, display: "inline-flex" }}>
                                            <CustomSelect
                                                name={"pzi_base_unit"}
                                                value={pziBaseUnitTmp}
                                                noSort={true}
                                                options={pziBaseUnitOptions}
                                                onChange={(e) => {
                                                    setPziBaseUnitTmp(e.target.value);
                                                    setPziUnits(calcPziUnits(e.target.value));
                                                    setSelectedUnitsTmp(calcSelectedUnits(e.target.value, selectedUnitsTmp))
                                                }}
                                            />
                                        </div>
                                        :
                                        <>
                                            <span>{pziBaseUnitDisplay}</span>
                                            { isEditMode && hasOpenOrderRequest ? 
                                                <span className={classes.pziOpenOrderRequests}>{I18n.get("pzi_open_order")}</span>
                                                :
                                                <></>
                                            }
                                        </>
                                    }
                                </div>
                                <PziUnitsList 
                                    isEditMode={isEditMode}
                                    pziUnits={selectedUnitsTmp} 
                                    productUnits={pziUnits} 
                                    setPziUnits={setSelectedUnitsTmp} 
                                    baseUOM={pziBaseUnitTmp}
                                />
                            </div>
                        </div>
                    </div>


                    :

                    <div></div>
            }
        </div>
    );



};

export { ProductAssociationBase };
export default withRouter(withStyles(styles)(ProductAssociationBase));
